import { render, staticRenderFns } from "./dialogResolvedProblem.vue?vue&type=template&id=6bb42f76&scoped=true"
import script from "./dialogResolvedProblem.vue?vue&type=script&lang=js"
export * from "./dialogResolvedProblem.vue?vue&type=script&lang=js"
import style0 from "./dialogResolvedProblem.vue?vue&type=style&index=0&id=6bb42f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb42f76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog})
